import React, { useEffect, useState } from "react";

import useArticleOpen from "../hooks/useArticleOpen";
import ArticleContent from "../Components/Articles/ArticleContent";

import { makeStyles } from "@material-ui/core/styles";
import setStyles from "../setStyles";
import { fetchArticle } from "../api/articles";
import { useReduxQuery } from "../hooks/useReduxQuery";
import RelatedArticle from "../Components/Articles/RelatedArticles";

const useStyles = makeStyles(() => ({
  container: {
    maxWidth: setStyles.maxWidth,
    margin: "110px auto auto",
  },
}));

export function articleStatus(article, loading, error) {
  if (article) return "ready";
  return loading && !error ? "loading" : "unavailable";
}

const Article = ({ match }) => {
  const id = match.params.id;

  const classes = useStyles();
  const { article, loadingArticle, errorArticle } = useReduxQuery("Article", () => fetchArticle(id), {
    selector: (state) => state.articles.data?.[id],
  });

  useArticleOpen(id,Boolean(article));
  // R35 (C6-new-007): an article assigned to other users or teams comes back empty, like a missing one.
  const status = articleStatus(article, loadingArticle, errorArticle);
  if (status !== "ready")
    return (
      <div className={classes.container}>
        {status === "unavailable" && <p role="status">This article is not available to your account.</p>}
      </div>
    );
  return (
    <div className={classes.container}>
      <ArticleContent article={article} />
      <RelatedArticle articles={article?.relatedArticles || []} />
    </div>
  );
};

export default Article;
